import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')

	return {
		"id": id,
		"elements": [{
			"type": "text",
			"id": "-GRePgt29m",
			"width": 478.4,
			"height": 98.45,
			"left": 21.6,
			"top": 160.31,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"content": `<p style=\"text-align: justify;\"><span style=\"font-size: 73.47px;\"><span style=\"font-family: 字体家AI造字剑客;\"><span style=\"color: #FEE6AE;\">${title}</span></span></span></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "text",
			"id": "Qkr-lvDmdP",
			"width": 173.57,
			"height": 30.29,
			"left": 25.220000000000002,
			"top": 355.53999999999996,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"content": "<p style=\"\"><span style=\"font-size: 18.37px;\"><span style=\"font-family: Arial;\"><span style=\"color: rgba(255,255,255,1);\">汇报人：ChatGpt</span></span></span></p>",
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "text",
			"id": "PGDUv0mpEd",
			"width": 118.12,
			"height": 37.87,
			"left": 31.274541120381407,
			"top": 122.44000000000001,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"content": "<p style=\"text-align: justify;\"><span style=\"font-size: 24.49px;\"><span style=\"font-family: Arial;\"><span style=\"color: rgba(255,255,255,1);\">总结汇报</span></span></span></p>",
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		}],
		background
	};

}